
    <cookie-law-component *ngIf="!seen"
                          [awsomeCloseIcon]="awsomeCloseIcon"
                          [learnMore]="learnMore"
                          [target]="target"
                          [position]="position"
                          (isSeen)="hasBeenDismissed()">
      <ng-content></ng-content>
    </cookie-law-component>
  